import { Frame, FrameType, ControlCodes } from '../types/protocol';
import { calculateTransmitCRC } from './crc16';
import { encodeData } from './encoding';

/**
 * Build a complete data frame with STX, encoded data+CRC, EOF
 */
export function buildDataFrame(data: Uint8Array): Uint8Array {
  const crc = calculateTransmitCRC(data);
  const dataWithCRC = new Uint8Array(data.length + 2);
  dataWithCRC.set(data);
  dataWithCRC[data.length] = (crc >> 8) & 0xFF;
  dataWithCRC[data.length + 1] = crc & 0xFF;

  const encoded = encodeData(dataWithCRC);

  const frame = new Uint8Array(encoded.length + 2);
  frame[0] = ControlCodes.STX;
  frame.set(encoded, 1);
  frame[frame.length - 1] = ControlCodes.EOF;

  return frame;
}

/**
 * Create a Frame object
 */
export function createFrame(
  type: FrameType,
  raw: Uint8Array,
  direction: 'tx' | 'rx'
): Frame {
  return {
    type,
    raw,
    decoded: { data: raw, crc: 0, crcValid: true },
    timestamp: Date.now(),
    direction
  };
}
